// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CardTcsWrapperModelsAccumulatorModel {
    static getAttributeTypeMap() {
        return CardTcsWrapperModelsAccumulatorModel.attributeTypeMap;
    }
}
CardTcsWrapperModelsAccumulatorModel.discriminator = undefined;
CardTcsWrapperModelsAccumulatorModel.additionalProperties = false;
CardTcsWrapperModelsAccumulatorModel.attributeTypeMap = [
    {
        "name": "medications",
        "baseName": "medications",
        "type": "Array<CardTcsWrapperModelsMedicationModel>"
    },
    {
        "name": "medicationMaxBenefit",
        "baseName": "medicationMaxBenefit",
        "type": "number"
    },
    {
        "name": "remainingMedicationBenefit",
        "baseName": "remainingMedicationBenefit",
        "type": "number"
    },
    {
        "name": "totalMedicationPaid",
        "baseName": "totalMedicationPaid",
        "type": "number"
    },
];
//# sourceMappingURL=cardTcsWrapperModelsAccumulatorModel.js.map